import * as Types from '../types-api.generated';

import { MomentOverviewFragment, MomentFragment, UserLightFragment, WorldOverviewFragment, WorldOverviewOnExhibition, MomentStatsFragment, MediaFragment, EditionSaleConfigurationFragment, DropSaleConfigurationFragment, TokenFragment, NftIdentifiersFragment, AuctionFragment, SaleFragment, SplitFragment } from '../api-fragments.generated';
import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';
import { apiFetcher } from 'lib/clients/graphql';

import { ClientError } from "graphql-request";
import { Address } from "viem";
import { ChainId } from "lib/chains";

export type ApiTokenPageVariables = Types.Exact<{
  tokenFilter: Types.ApiTokenInput;
}>;


export type ApiTokenPage = { moment: { id: number, name: string, description: string | null, worldId: number, posterUrl: string, startsAt: string, takeRateInBasisPoints: number, curator: { name: string | null, profileImageUrl: string | null, username: string | null, publicKey: Address }, world: { chainId: ChainId, id: number, name: string, slug: string, moderationStatus: Types.ApiModerationStatus, imageUrl: string | null, coverUrl: string | null, takeRateInBasisPoints: number, curator: { name: string | null, profileImageUrl: string | null, username: string | null, publicKey: Address } } } | null, world: { chainId: ChainId, id: number, name: string, slug: string, moderationStatus: Types.ApiModerationStatus, imageUrl: string | null, coverUrl: string | null, takeRateInBasisPoints: number, curator: { name: string | null, profileImageUrl: string | null, username: string | null, publicKey: Address } } | null, token: { __typename: 'ERC1155Token', chainId: ChainId, contractAddress: Address, tokenId: number } | { __typename: 'MarketNft', id: string, name: string | null, description: string | null, saleStartsAt: string | null, metadataUrl: string | null, sourceUrl: string | null, moderationFrom: string | null, moderationStatus: Types.ApiModerationStatus, chainId: ChainId, contractAddress: Address, tokenId: number, activeAuction: { duration: number, expiryDate: string | null, id: number, reservePrice: number, state: Types.ApiAuctionState, highestBid: { amount: number, bidder: { name: string | null, profileImageUrl: string | null, username: string | null, publicKey: Address } } | null } | null, activeBuyNow: { amount: number } | null, activeOffer: { amount: number, expiryDate: string } | null, collection: { chainId: ChainId, collectionImageUrl: string | null, contractAddress: Address, contractType: Types.ApiContractType, coverImageUrl: string | null, moderationFrom: string | null, moderationStatus: Types.ApiModerationStatus, name: string, slug: string, symbol: string }, creator: { name: string | null, profileImageUrl: string | null, username: string | null, publicKey: Address }, owner: { name: string | null, profileImageUrl: string | null, username: string | null, publicKey: Address } | null, lastSale: { amount: number, date: string, type: Types.ApiSaleType, worldId: number | null, buyer: { name: string | null, profileImageUrl: string | null, username: string | null, publicKey: Address } } | null, media: { __typename: 'ImageMedia', processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, url: string, imageMimeType: Types.ApiImageMimeType } | { __typename: 'ModelMedia', processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, url: string, modelMimeType: Types.ApiModelMimeType, modelStaticUrl: string } | { __typename: 'VideoMedia', previewUrl: string | null, processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, staticUrl: string | null, url: string, videoMimeType: Types.ApiVideoMimeType } | null } | null, splits: Array<{ sharePercent: number, user: { name: string | null, profileImageUrl: string | null, username: string | null, publicKey: Address } }> };



export const ApiTokenPageDocument = /*#__PURE__*/ `
    query TokenPage($tokenFilter: TokenInput!) {
  moment(by: {token: $tokenFilter}) {
    ...MomentOverviewFragment
  }
  world(by: {token: $tokenFilter}) {
    ...WorldOverviewFragment
  }
  token(by: {token: $tokenFilter}, moderationFilter: ALL) {
    ...TokenFragment
  }
  splits(by: {token: $tokenFilter}) {
    ...SplitFragment
  }
}
    ${MomentOverviewFragment}
${MomentFragment}
${UserLightFragment}
${WorldOverviewFragment}
${TokenFragment}
${NftIdentifiersFragment}
${AuctionFragment}
${SaleFragment}
${MediaFragment}
${SplitFragment}`;

export const useTokenPage = <
      TData = ApiTokenPage,
      TError = ClientError
    >(
      variables: ApiTokenPageVariables,
      options?: Omit<UseQueryOptions<ApiTokenPage, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ApiTokenPage, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ApiTokenPage, TError, TData>(
      {
    queryKey: ['TokenPage', variables],
    queryFn: apiFetcher<ApiTokenPage, ApiTokenPageVariables>(ApiTokenPageDocument, variables),
    ...options
  }
    )};

useTokenPage.getKey = (variables: ApiTokenPageVariables) => ['TokenPage', variables];

export const useInfiniteTokenPage = <
      TData = InfiniteData<ApiTokenPage>,
      TError = ClientError
    >(
      variables: ApiTokenPageVariables,
      options: Omit<UseInfiniteQueryOptions<ApiTokenPage, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ApiTokenPage, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ApiTokenPage, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['TokenPage.infinite', variables],
      queryFn: (metaData) => apiFetcher<ApiTokenPage, ApiTokenPageVariables>(ApiTokenPageDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteTokenPage.getKey = (variables: ApiTokenPageVariables) => ['TokenPage.infinite', variables];


useTokenPage.fetcher = (variables: ApiTokenPageVariables, options?: RequestInit['headers']) => apiFetcher<ApiTokenPage, ApiTokenPageVariables>(ApiTokenPageDocument, variables, options);
